import http from "../http-common";
import authHeader from "./authHeader";
import { EMPLOYEE_API } from "../api";

const getAllEmployees = () => {
  return http.get(`${EMPLOYEE_API}`, { headers: authHeader() });
};

const getEmployeeById = (id) => {
  return http.get(`${EMPLOYEE_API}/${id}`, { headers: authHeader() });
};

const createEmployee = (data) => {
  return http.post(`${EMPLOYEE_API}`, data, { headers: authHeader(), "Content-Type": "multipart/form-data" });
};
const resignEmployee = (id) => {
  return http.put(`${EMPLOYEE_API}/${id}`, { role: null }, { headers: authHeader() });
};

const resetPasswordEmployee = (id, data) => {
  return http.put(`${EMPLOYEE_API}/password-reset/${id}`, data, { headers: authHeader() });
};

const assignEmployee = (id, role) => {
  return http.put(`${EMPLOYEE_API}/${id}`, { role }, { headers: authHeader() });
};
const updateEmployee = (id, data) => {
  return http.put(`${EMPLOYEE_API}/${id}`, data, { headers: authHeader() });
};

const removeEmployee = (id) => {
  return http.delete(`${EMPLOYEE_API}/${id}`, { headers: authHeader() });
};
//Need other files upload
const EmployeeService = {
  getAllEmployees,
  getEmployeeById,
  createEmployee,
  updateEmployee,
  removeEmployee,
  resignEmployee,
  assignEmployee,
  resetPasswordEmployee,
};

export default EmployeeService;
